import React from 'react';
import { Btn } from './components.jsx';
import { _i18nStrings, t } from './i18n.js';
const { useState, useEffect } = React;

// ============================================================================
// DRAWER — Sliding right panel with content tabs
// Drawer content is loaded from the i18n bundle (drawers.<panel>.title/lead/sections)
// ============================================================================

function _getDrawerContent(panel) {
  if (!panel) return null;
  // Read raw object from the i18n strings (not via t() because we need nested arrays).
  const all = (typeof _i18nStrings === 'function') ? _i18nStrings() : {};
  return (all && all.drawers && all.drawers[panel]) || null;
}

// Split a section body into paragraphs at the markers "Enthalten:" / "Geeignet für:"
// (DE) and "Included:" / "Suitable for:" (EN). The marker itself is bolded.
// Used by the advisory drawers where each package describes inclusions + fit.
const _BODY_MARKERS = ['Enthalten:', 'Geeignet für:', 'Included:', 'Suitable for:'];
function _renderDrawerBody(text) {
  const escaped = _BODY_MARKERS.map(m => m.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const splitRe = new RegExp(`(?=${escaped.join('|')})`);
  const parts = text.split(splitRe).map(s => s.trim()).filter(Boolean);
  return parts.map((p, i) => {
    const marker = _BODY_MARKERS.find(m => p.startsWith(m));
    if (marker) {
      const rest = p.slice(marker.length);
      return (
        <p key={i} className="drawer__section-body">
          <strong>{marker}</strong>{rest}
        </p>
      );
    }
    return <p key={i} className="drawer__section-body">{p}</p>;
  });
}

const Drawer = ({ open, panel, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && open) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  // Re-render on locale change so content refreshes
  const [, _bump] = useState(0);
  useEffect(() => {
    const onLocale = () => _bump(n => n + 1);
    document.addEventListener('locale-changed', onLocale);
    return () => document.removeEventListener('locale-changed', onLocale);
  }, []);

  const c = _getDrawerContent(panel);

  return (
    <>
      <div className={`drawer-scrim ${open ? 'is-open' : ''}`} onClick={onClose}></div>
      <aside className={`drawer ${open ? 'is-open' : ''}`} role="dialog" aria-modal="true" aria-hidden={!open}>
        {c && (
          <>
            <div className="drawer__head">
              <span className="drawer__title">{c.title}</span>
              <Btn kind="ghost" variant="icon" icon="xmark" onClick={onClose} aria-label={t('common.close')}/>
            </div>
            <div className="drawer__body">
              {(c.lead || '').split('\n\n').map((p, i) => (
                <p key={i} className="drawer__lead">{p}</p>
              ))}
              {(c.sections || []).map((s, i) => (
                <div key={i} className="drawer__section">
                  <h4>{s.h}</h4>
                  {s.body && _renderDrawerBody(s.body)}
                  {s.items && s.items.length > 0 && (
                    <ul>{s.items.map((it, j) => <li key={j}>{it}</li>)}</ul>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export { Drawer };
